/* Global sticky header */
// $(window).scroll(function () {
//   if ($(this).scrollTop() > 0) {
//     $("main-header#site-header").addClass("fixed");
//   } else {
//     $("main-header#site-header").removeClass("fixed");
//   }
// });

/* Sticky header search */
$(document).ready(function () {
  $(".desktop-search-button").click(function () {
    $(".desktop-search-form").toggleClass("display-search");
    $(".desktop-search-form form input").focus();
  });
  $(".desk-close-search").click(function () {
    $(".desktop-search-form").toggleClass("display-search");
  });
  $(".mobile-close-search").click(function () {
    $("#myDIV").toggleClass("show");
  });
  $(".mobile-search-button").click(function () {
    $("#myDIV form input").focus();
  });
});

/* Sticky cart on scroll */
$(window).scroll(function () {
  var productCartFunctions = $(".section-main__payment-icons");
  var csProduct = $(".cs-product");
  if ($(".cs-product")[0]) {
    var scrollTop = $(window).scrollTop();
    if (scrollTop > productCartFunctions.offset().top) {
      csProduct.show();
      $("body").addClass("sticky-cart-show");
    } else {
      csProduct.hide();
      $("body").removeClass("sticky-cart-show");
    }
  }
});

/* Sliders Video products */
$(document).ready(function () {
  // Initialize slick slider
  $(".videos-slider-wrapper").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  // Handle video autoplay on slide change
  $(".videos-slider-wrapper").on(
    "afterChange",
    function (event, slick, currentSlide) {
      // Pause all videos
      $(".slider-videos").each(function () {
        this.pause();
      });

      // Find the video in the current slide and play it
      var currentSlideVideo = $(".slick-active .slider-videos")[0];
      if (currentSlideVideo) {
        currentSlideVideo.play();
      }
    }
  );
});
/* Product tabs */
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-link");
  const contents = document.querySelectorAll(".tab-content");

  // Set the first tab and content to be active by default
  if (tabs.length > 0 && contents.length > 0) {
    tabs[0].classList.add("current");
    contents[0].classList.add("current");
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      // Remove active class from all tabs and content
      tabs.forEach((tab) => tab.classList.remove("current"));
      contents.forEach((content) => content.classList.remove("current"));

      // Add active class to the clicked tab and corresponding content
      tab.classList.add("current");
      const activeContent = document.getElementById(tab.getAttribute("data-tab"));
      activeContent.classList.add("current");
    });
  });
});
/* Customer quotes slider*/
$(document).ready(function () {
  $(".quotes-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    arrows: false,
    dots: false,
    speed: 500,
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024, // Tablet breakpoint
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767, // Mobile breakpoint
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});



$(document).ready(function () {
  $(".tr-images-slides").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    dots: false,
    arrows: true,
    speed: 300,
    centerPadding: "20px",
    infinite: true,
    asNavFor: ".tabs-slider, .btn-slider-tabs",
    prevArrow: $('.slider-images-module .prev-arrow'),  // Correct selector for previous arrow
    nextArrow: $('.slider-images-module .next-arrow')   // Correct selector for next arrow
  });

  $(".tabs-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".tr-images-slides, .btn-slider-tabs",
    focusOnSelect: true,
  });
  $(".btn-slider-tabs").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: ".tr-images-slides, .tabs-slider",
    fade: true,
    focusOnSelect: true,
  });
});
// ES Site // 
document.addEventListener("DOMContentLoaded", function () {
  if (window.location.href.includes("https://www.zecplus.it/")) {
    document.body.classList.add("it-site");
  }
});
/* Transparency tabs*/
$(document).ready(function () {
  $(".tabs-slider").on("click", ".tab", function () {
    var $currentSlide = $(this).closest(".slick-slide");

    // Remove active classes within the current slide
    $currentSlide.find(".tab").removeClass("active-tab");
    $currentSlide.find(".tab-content").removeClass("active-content");

    // Add active classes to the clicked tab and corresponding content
    $(this).addClass("active-tab");
    $currentSlide.find("#" + $(this).data("target")).addClass("active-content");
  });
});

$(document).ready(function () {
  // Initialize slick slider for supply slices
  $(".supply-slices").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    loop: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".slices.prev-btn").click(function () {
    $(".supply-slices").slick("slickPrev");
  });

  $(".slices.next-btn").click(function () {
    $(".supply-slices").slick("slickNext");
  });
});
$(document).ready(function () {
  // Initialize slick slider for support slices
  $(".support-slices").slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
    loop: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });
  $(".support.prev-btn").click(function () {
    $(".support-slices").slick("slickPrev");
  });

  $(".support.next-btn").click(function () {
    $(".support-slices").slick("slickNext");
  });
});

// Initialize slick slider for socials gallery
$(document).ready(function () {
  $(".zec-gallery").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    centerMode: false,
    dots: false,
    speed: 500,
    infinite: true,
    autoplaySpeed: 4000,
    autoplay: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

/* Footer accordion mob*/
$(document).ready(function () {
  function initToggle() {
    if (window.matchMedia("(max-width: 767px)").matches) {
      $(".footer--grid-main").removeClass("open");
      $(".toggling-content").removeClass("main").slideUp(); // Hide all contents

      $(".footer-item__title")
        .off("click")
        .on("click", function () {
          var $footerGridMain = $(this).closest(".footer--grid-main");
          if ($footerGridMain.hasClass("open")) {
            $footerGridMain.removeClass("open");
            $footerGridMain
              .find(".toggling-content")
              .removeClass("main")
              .slideUp();
          } else {
            $(".footer--grid-main").removeClass("open");
            $(".toggling-content").removeClass("main").slideUp();
            $footerGridMain.addClass("open");
            $footerGridMain
              .find(".toggling-content")
              .addClass("main")
              .slideDown();
          }
        });
    } else {
      $(".footer-item__title").off("click");
      $(".toggling-content").removeClass("main").show();
    }
  }
  initToggle();
  $(window).resize(initToggle);
});


/* mobile menu drawer*/
$(document).ready(function () {
  $("#burger-icon").addClass("cs-show");
  $("#close-icon").addClass("hidden");
  $("#burger-icon").click(function () {
    $(this).addClass("hidden");
    $("#close-icon").removeClass("hidden").addClass("cs-show");
  });
  $("#close-icon").click(function () {
    $(this).addClass("hidden"); // Hide close icon
    $("#burger-icon").removeClass("hidden").addClass("cs-show");
  });
});


/* variant image  */
document.addEventListener('DOMContentLoaded', function() {
    const variantSelect = document.getElementById('variant-select');
    const thumbnails = document.querySelectorAll('.product-gallery__thumbnails .thumbnail');

    function updateThumbnails() {
        const selectedVariant = variantSelect.value;

        thumbnails.forEach(thumbnail => {
            const img = thumbnail.querySelector('img');
            if (img) {
                const altText = img.getAttribute('alt');
                if (altText === selectedVariant) {
                    thumbnail.style.display = 'block';
                } else {
                    thumbnail.style.display = 'none';
                }
            }
        });
    }
    variantSelect.addEventListener('change', updateThumbnails);
    updateThumbnails();
});

document.addEventListener('DOMContentLoaded', function() {
    var variantSelect = document.getElementById('variant-select');
    var productImage = document.querySelector('#zec-media-product-cs .variant-image');

    function updateImageBasedOnSelectedVariant() {
        if (!variantSelect) {
            console.error('Variant select element not found.');
            return;
        }

        var selectedOption = variantSelect.options[variantSelect.selectedIndex];
        var newImageSrc = selectedOption.getAttribute('data-img');

        if (newImageSrc && productImage) {
            productImage.src = newImageSrc;
        } else if (!newImageSrc) {
            console.warn('Selected option does not have a data-img attribute. Skipping image update.');
        } else {
            console.warn('Product image element not found. Skipping image update.');
        }
    }
    updateImageBasedOnSelectedVariant();
    if (variantSelect) {
        variantSelect.addEventListener('change', updateImageBasedOnSelectedVariant);
    }
});

/* collection page tabs */
$(document).ready(function () {
  $(".cs-products-grid-main-products").hide();
  $(".cs-products-grid-main-products.active").show();
  $(".single-tab").on("click", function () {
    $(".single-tab").removeClass("active");
    $(this).addClass("active");
    var tabId = $(this).data("element-id");
    $(".cs-products-grid-main-products").removeClass("active").hide();
    $('.cs-products-grid-main-products[data-element-id="' + tabId + '"]')
      .addClass("active")
      .show();
  });
});

/* collection page sticky checkout */
document.addEventListener('scroll', function() {
    var originalATC = document.querySelector('.cs-products-grid-main'); // Product grid section
    var stickyATC = document.querySelector('#sticky-atc'); // Sticky cart
    var chatButton = document.querySelector('#ShopifyChat'); // Sticky cart
    var footer = document.querySelector('.main-footer'); // Footer section

    var originalPosition = originalATC.getBoundingClientRect().top + window.scrollY; // Top of the product grid
    var footerPosition = footer.getBoundingClientRect().top + window.scrollY; // Top of the footer

    // Check if the user has scrolled past the product grid section and hasn't reached the footer yet
    if (window.scrollY > originalPosition && window.scrollY + window.innerHeight < footerPosition) {
        // Make the sticky cart visible and fixed at the bottom of the viewport when scrolling within the grid section
        stickyATC.style.display = 'block';
        stickyATC.style.position = 'fixed';
        stickyATC.style.bottom = '0px';
        stickyATC.style.left = '0';
        stickyATC.style.right = '0';
        if(chatButton){ chatButton.style.bottom = "120px"; }
    } else if (window.scrollY + window.innerHeight >= footerPosition) {
        // If the user scrolls past the grid and reaches the footer, stop the sticky behavior and keep it above the footer
        stickyATC.style.position = 'absolute';
        stickyATC.style.bottom = '0'; // Stick the cart to the bottom of the product grid
        stickyATC.style.display = 'block'; // Ensure it remains visible above the footer
        if(chatButton){ chatButton.style.bottom = "16px"; }
    } else {
        // If the user scrolls back up before reaching the product grid section, hide the sticky cart
        stickyATC.style.display = 'none';
        stickyATC.style.position = 'relative';
        stickyATC.style.bottom = 'auto';
        if(chatButton){ chatButton.style.bottom = "16px"; }
    }
});

/* PDP Table Wrapper */ 
document.addEventListener("DOMContentLoaded", function() {
    const tables = document.querySelectorAll('.pro-single-tab-wrapper table');
    tables.forEach(function(table) {
        const tbody = table.querySelector('tbody');

        // Check if <tbody> has any content
        if (!tbody || tbody.children.length === 0) {
            // Hide the table if <tbody> is empty
            table.style.display = 'none';
        } else {
            // Wrap the table in a div if it has content
            const wrapper = document.createElement('div');
            wrapper.className = 'nutrition-table';
            table.parentNode.insertBefore(wrapper, table);
            wrapper.appendChild(table);
        }
    });
});

// Function to toggle class based on body class
function toggleSidebarClass() {
  const body = document.body;
  const mainElement = document.querySelector('.main-cls');

  if (!mainElement) return;

  if (body.classList.contains('sidebar-opened')) {
    mainElement.classList.add('html-sidebar-opened');
  } else {
    mainElement.classList.remove('html-sidebar-opened');
  }
}

// Observe changes to the body class
const observer = new MutationObserver(() => {
  toggleSidebarClass();
});

// Start observing the body for class changes
observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

// Initial check on page load
toggleSidebarClass();


/* PDP rewards*/ 
   document.addEventListener('DOMContentLoaded', function() {
    const tooltipTriggers = document.querySelectorAll('.points-value-trigger');
    const tooltips = document.querySelectorAll('.points-tooltip');
    
    // Function to show the tooltip
    function showTooltip(tooltip) {
      tooltip.classList.add('points-tooltip-visible');
    }
    
    // Function to hide the tooltip
    function hideTooltip(tooltip) {
      tooltip.classList.remove('points-tooltip-visible');
    }
    
    tooltipTriggers.forEach((trigger, index) => {
      const tooltip = trigger.closest('.points-text-container').querySelector('.points-tooltip');
      
      // Handle mouse hover (for desktop)
      trigger.addEventListener('mouseenter', function() {
        showTooltip(tooltip);
      });
      
      trigger.addEventListener('mouseleave', function() {
        hideTooltip(tooltip);
      });
      
      // Handle click (especially for mobile)
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        if (tooltip.classList.contains('points-tooltip-visible')) {
          hideTooltip(tooltip);
        } else {
          // Hide any other visible tooltips
          tooltips.forEach(t => hideTooltip(t));
          showTooltip(tooltip);
        }
      });
      
      // Handle keyboard accessibility
      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (tooltip.classList.contains('points-tooltip-visible')) {
            hideTooltip(tooltip);
          } else {
            showTooltip(tooltip);
          }
        }
      });
      
      // Close tooltip when clicking outside
      document.addEventListener('click', function(e) {
        if (!trigger.contains(e.target) && !tooltip.contains(e.target)) {
          hideTooltip(tooltip);
        }
      });
    });
  });


  document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(() => {
      const pTag = document.querySelector(".slp_13efdb strong");

      if (pTag) {
        observer.disconnect(); // stop observing once found

        function appendText(targetP) {
          const existingDiv = targetP.parentNode.querySelector(".custom-lorem-text");
          if (!existingDiv) {
            const div = document.createElement("div");
            div.textContent = "Ogni 100 punti = €1 di sconto sul tuo prossimo ordine";
            div.className = "custom-lorem-text";
            targetP.parentNode.appendChild(div);
          }
        }

         function removeText(targetP) {
          const existingDiv = targetP.parentNode.querySelector(".custom-lorem-text");
          if (existingDiv) {
            existingDiv.remove();
            console.log("❌ Removed custom text on mouse leave.");
          }
        }

        document.addEventListener("click", function (event) {

           const clickedP = event.target.closest(".slp_13efdb p");
          if (clickedP) {
            console.log("✅ Smile <p> clicked!");
            appendText(clickedP);
          }
          
          
        });

        // Append on mouseenter
        document.addEventListener("mouseenter", function (event) {
          const hoverP = event.target.closest(".slp_13efdb p");
          if (hoverP) {
            appendText(hoverP);
          }
        }, true); // Capture phase to make sure it catches bubbling
        

         document.addEventListener("mouseleave", function (event) {
          const leaveP = event.target.closest(".slp_13efdb p");
          if (leaveP) {
            removeText(leaveP);
          }
        }, true);
        
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });


